<template>
  <div class="container member-withdraw-list">
    <gobuy-head :title="$t('Withdraw')" />
    <div class="zhanweifu" style="height: 4.2rem;" v-if="!$IFR.is_iframe"></div>

    <body>
      <div class="content" style="padding-bottom: 1px;">
        <div class="centerbox">
          <div class="field-line-right" slot="right" style="padding-top: 10px;">
            <span v-if="address_type == 'BEP20'">USDT-BNB Smart Chain (BEP20)</span>
            <span v-else>USDT Address (opBNB)</span>
          </div>
          <flex-line
            v-if="bank_length > 0"
            class="field-line menu-item input-wrapper"
            :show-border="true"
          >
            <div class="field-line-right" slot="right">
              <span
                class="field-input"
                style="
                  word-wrap: break-word;
                  white-space: normal;
                  text-align: left;
                  display: inline-block;
                  width: 100%;
                "
              >
                {{ usdt_address }}
              </span>
            </div>
          </flex-line>

          <flex-line
            class="field-line menu-item input-wrapper"
            :show-border="true"
          >
            <span class="field-name">
              {{ $t("Withdrawal Amount") }}
            </span>
            <div class="field-line-right" slot="right">
              <input
                class="field-input"
                :placeholder="$t('Please enter')"
                type="number"
                v-model="amount"
              />
            </div>
          </flex-line>

          <flex-line
            class="field-line menu-item input-wrapper"
            :showPassword="showPassword"
            :toggleVisibility="toggleVisibility"
            :isPassword="true"
          >
            <span class="field-name">
              {{ $t("Payment Password") }}
            </span>
            <div class="field-line-right" slot="right">
              <input
                class="field-input"
                :type="showPassword ? 'text' : 'password'"
                :placeholder="$t('Please enter')"
                type="password"
                v-model="password"
              />
            </div>
          </flex-line>

          <div class="flex" style="dmargin-top: 0.5rem">
            <div class="f balance" style="text-align: left" @click="onRetrieve">
              {{ $t("Forgot Password") }}?
            </div>
            <div class="balance">
              {{ $t("Available Balance") }}: {{ available_predeposit }}
            </div>
          </div>
          <!-- 邮箱验证码 -->
          <flex-line class="field-line input-wrapper" :show-border="true" style="background: #fafafa;border-radius: 5px;">
            <span class="field-name">{{ $t('Email.verification.code') }}</span>
            <div class="field-line-right" slot="right">
              <input class="field-input" type="number" maxlength="6" v-model="email_code"
                :placeholder="$t('Please enter')"
                :attr="{ oninput: 'if(value.length>6)value=value.slice(0,6)' }" />
              <div @click="sendVerifyCode" class="common-btn send-btn">{{ sendStateTextMobile }}</div>
            </div>
          </flex-line>
          <div
            class="common-btn ds-button-large"
            @click="addWithdraw"
            v-if="btnShow"
          >
            {{ $t("Submit") }}
          </div>
          <div
            class="common-btn ds-button-large"
            @click="goMemberbacklist"
            v-else
          >
            {{ $t("Add Recipient Account First") }} >>
          </div>
        </div>
        <div class="fundet">
          <div class="tit">{{ $t("Withdrawal Details") }}</div>

          <div
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="loading"
            infinite-scroll-distance="10"
            style="padding-bottom: 10px"
          >
            <div class="list-wrapper"v-if="withdraw_list && withdraw_list.length">
              <div class="container" v-for="(item, index) in withdraw_list" :key="item.pdc_id">
                <div class="top-wrapper">
                  <div class="left-wrapper">
                    <label class="status">{{ item.pdc_payment_state_text }}</label>
                    <label class="title">{{ $t("address") }}: {{ item.pdc_bank_no }}</label>
                  </div>
                  <div class="right-wrapper">
                    <label class="price">${{ item.pdc_amount }}</label>
                    <label class="subtitle">{{ $t("Withdrawal Amount") }}</label>
                  </div>
                  <!-- <div class="top-line"></div> -->
                </div>
                <div class="center-wrapper" v-if="item.reason">
                  <label class="desc" style="color: #fb2630">{{ $t("Cause of failure") }}: {{ item.reason }}</label>
                </div>
                <div class="center-wrapper">
                  <label class="desc">{{ $t("Application Time") }}:{{ item.pdc_addtime_text }}</label>
                </div>
              </div>
            </div>
            <empty-record v-else-if="withdraw_list && !withdraw_list.length"></empty-record>
          </div>
        </div>
      </div>
    </body>

    <!-- Identity Verification -->
    <!-- <mt-popup
      v-model="sendAuthCode"
      position="right"
      class="common-popup-wrapper"
    >
      <div class="common-header-wrap">
        <mt-header title="Identity Verification" class="common-header">
          <mt-button
            slot="left"
            icon="back"
            @click="sendAuthCode = false"
          ></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
        <common-send-code @checkSuccess="checkSuccess" />
      </div>
    </mt-popup> -->

    <!-- Withdrawal Application -->
    <mt-popup
      v-model="addWithdrawVisible"
      position="right"
      class="common-popup-wrapper"
    >
      <div class="common-header-wrap">
        <mt-header :title="$t('Withdraw')" class="common-header">
          <mt-button
            slot="left"
            icon="back"
            @click="addWithdrawVisible = false"
          ></mt-button>
        </mt-header>
      </div>
      <div class="common-popup-content">
        <div class="main-content">
          <flex-line class="field-line menu-item" :show-border="true">
            <span class="field-name">{{ $t("Withdrawal Amount") }}</span>
            <div class="field-line-right" slot="right">
              <input class="field-input" type="number" v-model="amount" />
            </div>
          </flex-line>

          <flex-line class="field-line menu-item" :show-border="true">
            <span class="field-name">{{ $t("Payment Password") }}</span>
            <div class="field-line-right" slot="right">
              <input class="field-input" type="password" v-model="password" />
            </div>
          </flex-line>

          <flex-line
            v-if="bank_length > 0"
            class="field-line menu-item"
            :show-border="true"
          >
            <span>{{ $t("USDT Address (opBNB)") }}</span>
            <div class="field-line-right" slot="right">
              <input class="field-input" v-model="usdt_address" readonly />
            </div>
          </flex-line>

          <div
            class="common-btn ds-button-large mt-20"
            @click="addWithdraw"
            v-if="bank_length > 0"
          >
            {{ $t("Submit") }}
          </div>
          <div
            class="common-btn ds-button-large mt-20"
            @click="goMemberbacklist"
            v-else
          >
            {{ $t("Add Recipient Account First") }}
          </div>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  getWithdrawList,
  addWithdraw,
  createToken,
} from "../../../api/memberWithdraw";
import { getMemberIndex } from "../../../api/member";
import { getBankList } from "../../../api/memberBank";
import { Toast, Indicator, MessageBox } from "mint-ui";
import EmptyRecord from "../../../components/EmptyRecord";
// import CommonSendCode from "../common/CommonSendCode";
import flexLine from "../../flexLine";
import { sendAuthEmailCode } from '../../../api/memberSetting'
export default {
  name: "MemberWithdrawList",
  components: {
    flexLine,
    EmptyRecord,
    // CommonSendCode,
  },
  data() {
    return {
      address_type: "",
      params: { page: 0, per_page: 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      bank_length: 0,
      amount: "",
      memberbankList: {},
      memberbankOptions: [],
      memberbank_name: "",
      memberbank_id: "",
      password: "",
      form_token: "",
      addWithdrawVisible: false,
      memberbankVisible: false,
      sendAuthCode: false,
      wrapperHeight: 0,
      withdraw_list: false,
      usdt_address: "",
      available_predeposit: 0.0,
      btnShow: true,
      showPassword: false,

      email_code: "",
      canSendEmail: true,
      verifyCodeMobile: '',
      sendStateTextMobile: this.$t('send'),
    };
  },
  created() {
    getMemberIndex().then(
      (response) => {
        if (response && response.result.member_info) {
          this.available_predeposit =
            response.result.member_info.available_predeposit;
        }
      },
      (error) => {}
    );
    getBankList()
      .then((res) => {
        let temp = res.result.bank_list;
        this.bank_length = temp.length;
        if (this.bank_length > 0) {
          this.usdt_address = temp[0].memberbank_no;
          this.memberbank_id = temp[0].memberbank_id;
          this.address_type = temp[0].address_type;
        } else {
          this.btnShow = false;
        }
      })
      .catch(function (error) {
        Toast(error.message);
      });
    createToken().then((res) => {
      if (res.code == 10000) {
        this.form_token = res.result.form_token;
      }
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.member.info,
    }),
  },
  mounted() {
    this.wrapperHeight = document.documentElement.clientHeight - 90;
  },
  methods: {
    sendVerifyCode(){
			if (!this.canSendEmail) {
				return
			}
      Indicator.open()
			sendAuthEmailCode().then(res => {
        Indicator.close()
				if (res.code != 10000) {
          // this.makecode_()
					Toast(res.message)
					return
				}
				this.canSendEmail = false
				let second = 180
				Toast(res.message)
				let _this = this
				this.timeIntervalMobile = setInterval(function () {
					if (second <= 0) {
						_this.canSendEmail = true
						_this.sendStateTextMobile = _this.$t('send')
						clearInterval(_this.timeIntervalMobile)
					} else {
						_this.sendStateTextMobile = second + 's'
					}
					second--
				}, 1000)
			}).catch(function (error) {
				Toast(error.message)
			})
		},
    toggleVisibility() {
      this.showPassword = !this.showPassword;
    },
    onRetrieve() {
      this.$router.push({
        name: "HomeMemberForget",
        query: { type: "pay_password" },
      });
    },
    setMemberBank(e) {
      this.memberbank_name = this.memberbankList[e];
      this.memberbankVisible = false;
    },
    addWithdraw() {
      let that = this;
      if (this.amount == "") {
        Toast(this.$t("Please enter") + this.$t("Withdrawal Amount"));
        return;
      }
      MessageBox({
        title: that.$t("MessageBox.Tips"),
        message:
          that.$t("MessageBox.Confirm") + " " + that.$t("Withdraw") + "?",
        confirmButtonText: that.$t("MessageBox.Confirm"),
        cancelButtonText: that.$t("MessageBox.Cancel"),
        showCancelButton: true,
      }).then((action) => {
        if (action == "confirm") {
          addWithdraw(
            this.amount,
            this.memberbank_id,
            this.password,
            this.form_token,
            this.address_type,
            this.email_code
          ).then((res) => {
              if (res.code == 10000) {
                this.password = ''
                this.amount = ''
                this.canSendEmail = true
                this.email_code = ''
                clearInterval(this.timeIntervalMobile)
						    this.sendStateTextMobile = this.$t('send')
                this.getWithdrawList(true)
              }
              Toast(res.message);
            })
            .catch(function (error) {
              Toast(error.message);
            });
        }
      });
    },
    checkSuccess() {
      this.addWithdrawVisible = true;
    },
    goAdd() {
      // if (!this.user.member_mobilebind && !this.user.member_emailbind) {
      //   Toast(this.$t('Please bind your mobile phone or email first'))
      //   this.$router.push({ name: 'MemberSetting' })
      // } else {
      this.addWithdrawVisible = true;
      // }
    },
    goBack() {
      this.$router.go(-1);
    },
    goMemberbacklist(backTo) {
      // this.$router.push({ name: 'MemberBankList' })
      this.$router.push({
        name: "MemberBankForm",
        query: { action: "add", backTo },
      });
    },
    loadMore() {
      this.loading = true;
      this.params.page = ++this.params.page;
      if (this.isMore) {
        this.loading = false;
        this.getWithdrawList(true);
      }
    },
    getWithdrawList() {
      Indicator.open();

      getWithdrawList(this.params)
        .then((res) => {
          Indicator.close();
          if (res.result.hasmore) {
            this.isMore = true;
          } else {
            this.isMore = false;
          }

          let temp = res.result.list;
          if (temp) {
            if (!this.withdraw_list) {
              this.withdraw_list = temp;
            } else {
              this.withdraw_list = this.withdraw_list.concat(temp);
            }
          }
        })
        .catch(function (error) {
          Indicator.close();
          Toast(error.message);
        });
    },
  },
};
</script>

<style scoped lang="scss">
.send-btn{color:#ffffff;}
.member-withdraw-list {
  min-height: 100vh;
  box-sizing: border-box;
}
.content {
  padding: 10px 12px;
  margin-bottom: 20px;
  .centerbox {
    background-image: url("../../../assets/image/walletpop.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    // background-position: center center;
    padding: 12px 1rem;

    .common-btn {
      margin: 1rem;
      background: linear-gradient(90deg, #e8090c 0%, #f3611e);
    }

    .balance {
      text-align: right;
      font-size: 0.6rem;
      color: #999;
    }
  }
}

.titlewd {
  padding: 0.5rem;
  font-size: 0.7rem;
  font-weight: 600;
  margin-top: 1rem;
}

.common-header-wrap {
  position: fixed;
  top: 54px;
  width: 100%;
  .common-header {
    background: rgba(232, 9, 12, 0.6);
    color: #fff;
    /* 平滑过渡效果 */
  }
}
.logo {
  position: fixed;
  top: 25px;
  left: 12px;
  z-index: 99;

  img {
    width: 3.5rem;
  }
}
.common-header {
  box-shadow: none;

  .btn {
    background: #000;
    color: #fff;
    box-shadow: 0px 2px 4px #d2d2d2;
  }
}
body {
  width: 100%;
  background-color: transparent;
  // position: fixed;
  top: 100px;
  height: 100vh;
  // overflow-y: auto;
}
.main-content {
  // background: #fff;
  padding: 0 $pageSpace;
}

.container {
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
}

.header {
  border-bottom: 1px solid #e8eaed;
}

.list-wrapper {
  background-color: #fff;
  margin-top: 1rem;
  border-radius: 20px 20px 20px 20px;
  border: 1px solid #e8eaed;
  padding: 1rem;

  .container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    background-color: #fff;
    padding: 0 0 0.75rem 0;
    border-bottom: 1px solid #e8eaed;

    &:last-child {
      border-bottom: none;
    }
  }

  .top-wrapper {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: stretch;
  }

  .left-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }

  .right-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }

  .status {
    font-size: $subFontSize;
    color: #5296db;
    margin-left: 0.75rem;
    margin-top: 0.65rem;
  }

  .title {
    font-size: $fontSize;
    color: #666666;
    margin-left: 0.75rem;
    margin-top: 0.25rem;
    margin-right: 0.5rem;
    margin-bottom: 0.2rem;
    width: 8rem;
    word-wrap: break-word;
    /* 强制文本换行到下一行 */
    white-space: normal;
    /* 默认情况下文本会在空白处换行，这里确保正常换行行为 */
    overflow-wrap: break-word;
    /* 类似于word-wrap，用于处理长单词或URL的换行 */
  }

  .price {
    font-size: $h1;
    color: $primaryColor;
    margin-right: 0.75rem;
    margin-top: 0.5rem;
    text-align: right;
  }

  .subtitle {
    font-size: $fontSize;
    color: #999999;
    margin-right: 0.75rem;
    margin-top: 0.25rem;
    margin-bottom: 0.5rem;
    text-align: right;
  }

  .top-line {
    position: absolute;
    left: 0.75rem;
    bottom: 0;
    right: 0;
    height: 1px;
    background-color: #e8eaed;
  }

  .desc {
    color: #999999;
    font-size: $fontSize;
    margin-left: 0.75rem;
    margin-top: 0.25rem;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .center-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    // border-bottom: 1px solid #e8eaed;
    padding-bottom: 0.25rem;
  }
}

.input-wrapper {
  display: flex;
  flex-direction: row;
  align-content: flex-start;
  align-items: center;
  background-color: #fff;
  // height: 2.2rem;
  // padding-left: 0.5rem;

  flex-direction: column;
  align-items: flex-start;
  margin: 0.4rem 0;

  .field-name {
    width: 100%;
    font-size: 14px;
    font-weight: 600;
    margin: 0.5rem 0;
  }

  input {
    flex: 1;
    font-size: $subFontSize;
    flex: 1;
    // width: 14.5rem;
    width: 100%;
    text-align: left !important;
    // border: 1px solid #cccccc;
    padding: 0.9rem;
    border-radius: 0.4rem;
    background: #fafafa;
    border-radius: 5px 5px 5px 5px;
  }

  .bottom-input {
    border-bottom-width: 0;
  }

  .field-line-right {
    width: 100%;
    word-wrap: normal;
    position: relative;
  }

  ::v-deep(.right) {
    width: 100%;
  }
}

.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.8rem 0;
}

.fundet {
  // padding: 1rem;
  // background: #ffffff;
  border-radius: 25px 25px 0 0;

  .tit {
    margin-bottom: 12px;
    display: inline-block;
    // background: #e7010c;
    color: black;
    padding: 0.5rem 0rem 0px;
    font-weight: bold;
    font-size: 16px;
    border-bottom: none; /* 取消默认下划线 */
    background-image: linear-gradient(
      90deg,
      #e8090c 30%,
      rgba(243, 97, 30, 0.8) 20%,
      /* 使用透明度让颜色过渡更加平滑 */ rgba(240, 240, 240, 0.9) 70%
        /* 使过渡部分更加柔和 */
    );
    background-size: 100% 5px; /* 下划线的高度 */
    background-repeat: no-repeat;
    background-position: bottom;
  }
}

::v-deep(.flex-line) {
  background-color: transparent;
  align-items: flex-start !important;
}
</style>
